import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const FailedToUploadFileAlert = ({ handleUploadFileFailed }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleUploadFileFailed}>
            <div>
                <Alert
                    severity="error"
                    contrast="normal"
                    width="toast"
                    onClose={handleUploadFileFailed}
                    title={formatMessage(Locale.success)}>
                    <AlertTitle>{formatMessage(Locale.error)}</AlertTitle>
                    {formatMessage(Locale.bulkImportUploadFileFailed)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default FailedToUploadFileAlert;
